// src/config/themeConfig.js
const themeConfig = {
  themes: {
    default: {
      // leftNavBackgroundColor: '#2c3e50', // old background
      // Professional deep blue palette
      leftNavBackgroundColor: '#1a4980',
      leftNavBackgroundSecondary: '#0f2d4e',  // for gradient background
      lightColor: '#e6f0fa',
      textColor: '#ffffff',
    },
    light: {
      // Professional light/neutral palette
      leftNavBackgroundColor: '#a0b1c3',
      leftNavBackgroundSecondary: '#f0f4f8',  // for gradient background
      lightColor: '#f8fafc',
      textColor: '#334155',
    },
    zalando: {
      // Enhanced Zalando palette
      leftNavBackgroundColor: '#ff6900',
      leftNavBackgroundSecondary: '#c1997e',  // for gradient background
      lightColor: '#fff8f3',
      textColor: '#1a1a1a',
    },
    corporate: {
      // Corporate blue palette
      leftNavBackgroundColor: '#0a3d62',
      leftNavBackgroundSecondary: '#051e31',  // for gradient background
      lightColor: '#e1f0ff',
      textColor: '#ffffff',
    },
    forest: {
      // Professional green palette
      leftNavBackgroundColor: '#2d6a4f',
      leftNavBackgroundSecondary: '#1b4332',  // for gradient background
      lightColor: '#e8f5ee',
      textColor: '#ffffff',
    },
    plum: {
      // Professional purple palette
      leftNavBackgroundColor: '#5a189a',
      leftNavBackgroundSecondary: '#3c096c',  // for gradient background
      lightColor: '#f0e6fa',
      textColor: '#ffffff',
    },
    graphite: {
      // Professional dark/slate palette
      leftNavBackgroundColor: '#334155',
      leftNavBackgroundSecondary: '#1e293b',  // for gradient background
      lightColor: '#f1f5f9',
      textColor: '#ffffff',
    },
  },
};

export default themeConfig;